<template>
    <div class="groups-summary">
      <div class='row'>
        <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
          <dean-section-title content='true'>
            <span slot='title'>
                <span class='avenir-heavy'>groepen</span>
            </span>
            <dean-section-title-item
                :icon='plusIcon'
                :content="true"
                @click.native="sectionRoute('standingData.groups.add')"
            >
              toevoegen
            </dean-section-title-item>
          </dean-section-title>
          <dean-table
              :data='groups'
              :columns="columns"
              :hover="true"
              @column-click='columnClick'
              @cell-click="cellClick">
          </dean-table>
          <dean-pagination
              :current-page='metaData.pageNumber'
              :total-items='metaData.totalResults'
              :items-per-page='metaData.itemsPerPage'
              :select-items-per-page='selectItemsPerPage'
              :visible-pages='metaData.visiblePages'
              @page-changed='paginationChanged'
              @items-per-page='itemsPerPageChanged'
          >
          </dean-pagination>
        </div>
      </div>
    </div>
</template>

<script lang="ts">
  import {Vue, Component} from 'vue-property-decorator';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import {mixins} from 'vue-class-component';

  import {
    // ICONS
    plusIcon,
    // COMPONENTS
    deanSectionTitle,
    deanSectionTitleItem,
    deanTable,
    deanPagination,
  } from '@deanone/dean-components';

  @Component({
    components: {
      plusIcon,
      deanSectionTitle,
      deanSectionTitleItem,
      deanTable,
      deanPagination,
    },
  })
  export default class List extends mixins(deanTableMixin) {
    // DATA
    public groups: any = [];
    public plusIcon: object = plusIcon;
    public columns: any = {
      name: {
        content: 'naam',
        align: 'left',
        sort: true,
        dql: 'name',
      },
      type: {
        content: 'type',
        align: 'left',
        sort: true,
        dql: 'type',
      },
      certificate: {
        content: 'certificaat',
        align: 'left',
        sort: true,
        dql: 'certificate',
      },
      service: {
        content: 'service',
        align: 'left',
        sort: true,
        dql: 'service',
      },
    };

    // COMPUTED
    get metaData() {
      return this.pageMeta;
    }

    get sideMenu(): object {
      return {
        title: {
          text: 'Groepen',
          mobile: {
            close: {
              text: 'Close',
            },
          },
        },
        filters: {
          title: 'filteren op groeptype',
          items: {
            all: {
              title: 'Alle groeptypes',
              name: 'standingData.groups',
              state: (this.$route.params.type ? '' : 'active'),
            },
            service: {
              title: 'Dienst',
              name: 'standingData.groups.filter',
              state: (this.$route.params.type === 'service' ? 'active' : ''),
              params: {type: 'service'},
            },
            certificate: {
              title: 'Certificaat',
              name: 'standingData.groups.filter',
              state: (this.$route.params.type === 'certificate' ? 'active' : ''),
              params: {type: 'certificate'},
            },
            recurringCommissionGroup: {
              title: 'Recurring Comission Group',
              name: 'standingData.groups.filter',
              state: (this.$route.params.type === 'recurringCommissionGroup' ? 'active' : ''),
              params: {type: 'recurringCommissionGroup'},
            },
            productGroup: {
              title: 'Productgroep',
              name: 'standingData.groups.filter',
              state: (this.$route.params.type === 'productGroup' ? 'active' : ''),
              params: {type: 'productGroup'},
            },
            productSubGroup: {
              title: 'Product Subgroep',
              name: 'standingData.groups.filter',
              state: (this.$route.params.type === 'productSubGroup' ? 'active' : ''),
              params: {type: 'productSubGroup'},
            },
            productClass: {
              title: 'Productklasse',
              name: 'standingData.groups.filter',
              state: (this.$route.params.type === 'productClass' ? 'active' : ''),
              params: {type: 'productClass'},
            },
            restrict: {
              title: 'Restrictiegroep',
              name: 'standingData.groups.filter',
              state: (this.$route.params.type === 'restrict' ? 'active' : ''),
              params: {type: 'restrict'},
            },
            exclude: {
              title: 'Uitsluitgroep',
              name: 'standingData.groups.filter',
              state: (this.$route.params.type === 'exclude' ? 'active' : ''),
              params: {type: 'exclude'},
            },
          },
        },
      };
    }

    public tableName(): string {
      return 'settings-groups';
    }

    // METHODS
    public cellClick(target: {
      cell: object, row: { id: string }, column: string,
    }) {
      this.$router.push({
        name: 'standingData.groups.edit',
        params: {id: target.row.id},
      });
    }

    public loadList(data: any): void {
      this.$store.dispatch('setLoadOverlay', true);
      this.$store.dispatch('requestGroups', data)
        .then(
          (response) => {
            this.groups = response.data.data.map((group: any) => {
              return {
                id: group.id,
                name: group.name ? group.name : '',
                type: group.type ? this.$t('tables.' + group.type) : '',
                certificate: group.certificate ? group.certificate.name : '',
                service: group.service ? group.service.name : '',
              };
            });

            this.updateMeta(response.data.meta);
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    public created() {
      this.setDefaultSort('name');
      this.pageMeta.type = this.$route.params.type;
      this.loadList(this.pageMeta);
      this.$store.dispatch('setStandingDataSideMenu', this.sideMenu);
    }
  }
</script>

<style lang="scss" scoped>

</style>
